import { Component, OnInit } from '@angular/core';
import { ISiteSetting } from 'src/app/shared/interfaces/siteSetting';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.css'
})
export class TermsComponent implements OnInit {

  terms: ISiteSetting;


  constructor(private apiService: ApiService) {}


  ngOnInit(): void {
    this.getContent()
  }

  getContent() {
    this.apiService.apiCall('get', '/api/SiteInfo/SiteRules').subscribe((res: any) => {
      console.log(res);
      
      this.terms = res.body.model;
    })
  }

}
